import { Header } from '@/components/Header';
import { Hero } from '@/components/Hero';
import { Products } from '@/components/Products';
import { EducationalSection } from '@/components/EducationalSection';
import { WhyChooseUs } from '@/components/WhyChooseUs';
import { Testimonials } from '@/components/Testimonials';
import { About } from '@/components/About';
import { Contact } from '@/components/Contact';
import { Footer } from '@/components/Footer';
import { useSEO } from '@/hooks/useSEO';

const Index = () => {
  useSEO('home');

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <Products />
        <EducationalSection />
        <WhyChooseUs />
        <Testimonials />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
